import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const BillingBanner = ({ billing, onAddCard, canPay }) => {
  if (!billing?.remind || billing.blocking) return null;

  const copy = billing.phase === 'grace'
    ? 'Your free trial has ended. Set up billing soon or your team will lose access to this account.'
    : billing.phase === 'past_due'
      ? 'The last payment failed. Update your card or you may lose access to this account.'
      : 'Your trial is ending soon. Add a card now so you keep access — you won’t be charged until the trial date.';

  return (
    <div className="border-b border-amber-200/80 bg-gradient-to-r from-amber-50 via-[#fff8ec] to-sky-50 text-amber-950">
      <div className="mx-auto flex max-w-[110rem] flex-col gap-2 px-4 py-2.5 sm:flex-row sm:items-center sm:gap-3">
        <div className="flex min-w-0 flex-1 items-start gap-2">
          <Icon name="ShieldAlert" size={16} className="mt-0.5 shrink-0 text-amber-700" />
          <p className="text-sm">{copy}</p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <Link
            to="/billing"
            className="inline-flex items-center rounded-lg border border-amber-300/80 bg-white/80 px-3 py-1.5 text-xs font-semibold text-amber-950 hover:bg-white"
          >
            View billing
          </Link>
          {canPay && (
            <button
              type="button"
              onClick={onAddCard}
              className="rounded-lg bg-amber-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-800"
            >
              Set up billing
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingBanner;
